import React from 'react'
import Container from '@/components/container'
import { cx } from '@/utils/strings'

export type ArticleListHeaderProps = {
  heading?: string
  children?: React.ReactNode
  subheading?: string
}

export default function ArticleListHeader({ heading, children, subheading }: ArticleListHeaderProps) {
  return (
    <div className="py-16 bg-dusk-gradient text-secondary-50 text-center">
      <Container className="lg:px-10">
        <h1 className={cx('mb-0', (!children || !subheading) && 'mb-6')}>{heading}</h1>
        {subheading && <h2 className="h4">{subheading}</h2>}
        {children}
      </Container>
    </div>
  )
}
